import { Theme } from '@mui/material';

const Backdrop = (theme: Theme) => {
  return {
  };
};

export default Backdrop;
